package com.evoapps.evoshift.ui.roster

import kotlin.math.abs
import kotlin.math.ln

/**
 * SH-161 (F5): a pinch on the roster grid in the zoom steps of Ctrl + the wheel (SH-169), so a
 * pinch, the wheel and Ctrl +/- move the same zoom. Each [stepScale] the fingers spread (or
 * close) is one step in (or out); what is left over waits for the next move of the same pinch.
 */
internal class PinchZoomSteps(stepScale: Float = 1.1f) {
    private val step = ln(stepScale)
    private var pending = 0f

    /** The steps for one move of the fingers that scaled their spread by [scale] (0 until a step is reached). */
    fun add(scale: Float): Int {
        if (!scale.isFinite() || scale <= 0f) return 0
        pending += ln(scale)
        // A float error short of a whole step (1.1 × 1.1) still counts as it.
        val steps = (pending / step + if (pending >= 0f) EPSILON else -EPSILON).toInt()
        pending -= steps * step
        if (abs(pending) < EPSILON * step) pending = 0f
        return steps
    }

    private companion object {
        const val EPSILON = 1e-4f
    }
}
